import React from "react";
import { twMerge } from "tailwind-merge";

export default function AuthLayout({ children, className }) {
  return (
    <div className="flex-grow flex overflow-y-auto pt-0 lg:pt-20">
      <div className={twMerge("space-y-3 max-w-md mx-auto w-full", className)}>
        <div className="p-2 lg:p-4 rounded-lg  sm:border border-violet-400">
          {children}
        </div>
      </div>
    </div>
  );
}
